// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__section--Q_QsB {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  background-color: #f8f9ff;
  border: 1px solid #e5edff;
  border-radius: 0.5rem;
}
.style__sectionHeader--mKm2F {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 0.75rem;
}
.style__sectionIcon--tkYk6 {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 2rem;
  height: 2rem;
  border-radius: 0.5rem;
  background-color: #e5edff;
  color: #0070cc;
}
.style__sectionHeaderText--vc4xR {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
}
.style__sectionTitle--n55YT {
  margin: 0;
  font-size: 0.9375rem;
  font-weight: 600;
  color: #313235;
}
.style__sectionDescription--dl0ul {
  margin: 0;
  font-size: 0.8125rem;
  color: #7d8287;
  line-height: 1.4;
}
.style__completedList--ozTF1 {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.style__completedRow--_oeer {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem;
  background-color: #fff;
  border: 1px solid #e3e4e8;
  border-radius: 0.5rem;
  min-height: 2.5rem;
}
.style__completedBadge--NUTr2 {
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #313235;
  min-width: 1.5rem;
}
.style__completedSeparator--XoYD9 {
  color: #afb2b6;
  font-size: 0.75rem;
  line-height: 1.5;
  user-select: none;
}
.style__completedText--OBGL8 {
  font-size: 0.875rem;
  line-height: 1.5;
  color: #62656a;
  flex: 1;
  min-width: 0;
  overflow-x: hidden;
  overflow-y: visible;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.style__pendingList--GmhWT {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.style__pendingRow--ETOTU {
  display: flex;
  flex-direction: row;
  gap: 0.75rem;
  align-items: flex-end;
  flex-wrap: wrap;
}
.style__fieldGroup--jb78B {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1;
  min-width: 8rem;
}
.style__fieldGroupWide--OlVvI {
  flex: 2;
  min-width: 10rem;
}
.style__fieldLabel--M5mGx {
  font-size: 0.75rem;
  color: #7d8287;
  line-height: 1.2;
}
.style__select--z3sil {
  flex: 1;
  min-width: 0;
}
.style__selectWide--WxH0i {
  flex: 2;
  min-width: 0;
}
.style__selectControl--AcvqG {
  width: 100%;
  background-color: #fff;
  border-radius: 0.5rem;
}
.style__selectControl--AcvqG .MuiOutlinedInput-notchedOutline {
  border-color: #e3e4e8;
}
.style__selectControl--AcvqG:hover .MuiOutlinedInput-notchedOutline {
  border-color: #bdbfc2;
}
.style__selectControl--AcvqG .MuiSelect-select {
  font-size: 0.875rem;
  color: #494c50;
}
.style__selectControl--AcvqG .MuiSvgIcon-root {
  color: #26c1f3 !important;
}
.style__actionButtons--hm8Pg {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
  padding-bottom: 1px;
}
.style__confirmButton--mNxtO {
  flex-shrink: 0;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.5rem !important;
  background-color: #c4ffcb !important;
  color: #00803e !important;
}
.style__confirmButton--mNxtO:hover {
  background-color: #63ff94 !important;
}
.style__confirmButton--mNxtO.Mui-disabled {
  background-color: #f1f2f4 !important;
  color: #afb2b6 !important;
}
.style__removeButton--NcplM {
  flex-shrink: 0;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.5rem !important;
  border: 1px solid #e3e4e8 !important;
  background-color: #fff !important;
  color: #7d8287 !important;
}
.style__removeButton--NcplM:hover {
  background-color: #f9fafa !important;
}
.style__removeButton--NcplM.Mui-disabled {
  color: #bdbfc2 !important;
  border-color: #f1f2f4 !important;
}
.style__completedRemoveButton--mNyLO {
  flex-shrink: 0;
  border-radius: 0.5rem !important;
  color: #d72a1d !important;
}
.style__completedRemoveButton--mNyLO:hover {
  background-color: rgba(215, 42, 29, 0.08) !important;
}
.style__tooltipWrapper--YviRN {
  display: inline-flex;
}
.style__addButton--nSsoT {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: none;
  cursor: pointer;
  color: #1287b8;
  font-size: 0.875rem;
  padding: 0;
  width: fit-content;
}
.style__addButton--nSsoT:hover {
  text-decoration: underline;
}
.style__emptyState--Tedj0 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem;
  border: 1.5px dashed #ccdeff;
  border-radius: 0.5rem;
  background-color: rgba(255, 255, 255, 0.8);
  font-size: 0.8125rem;
  color: #7d8287;
}
.style__emptyStateIcon--Tta_Y {
  color: #0070cc;
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./../components/src/LicensesWithDetailsInput/style.less"],"names":[],"mappings":"AAGA;EAEI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,yBAAA;EACA,yBAAA;EACA,qBAAA;AAHJ;AALA;EAYI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAJJ;AAXA;EAmBI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;AALJ;AAtBA;EA+BI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;AANJ;AA5BA;EAsCI,SAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;AAPJ;AAlCA;EA6CI,SAAA;EACA,oBAAA;EACA,cAAA;EACA,gBAAA;AARJ;AAxCA;EAqDI,aAAA;EACA,sBAAA;EACA,WAAA;AAVJ;AA7CA;EA2DI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;AAXJ;AAxDA;EAuEI,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAZJ;AA/DA;EA+EI,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAbJ;AArEA;EAsFI,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,OAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AAdJ;AAhFA;EAmGI,aAAA;EACA,sBAAA;EACA,SAAA;AAhBJ;AArFA;EAyGI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;AAjBJ;AA5FA;EAiHI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,OAAA;EACA,eAAA;AAlBJ;AAnGA;EAyHI,OAAA;EACA,gBAAA;AAnBJ;AAvGA;EA8HI,kBAAA;EACA,cAAA;EACA,gBAAA;AApBJ;AA5GA;EAoII,OAAA;EACA,YAAA;AArBJ;AAhHA;EAyII,OAAA;EACA,YAAA;AAtBJ;AApHA;EA8II,WAAA;EACA,sBAAA;EACA,qBAAA;AAvBJ;AAzHA;EAmJM,qBAAA;AAvBN;AA0BI;EACE,qBAAA;AAxBN;AA/HA;EA2JM,mBAAA;EACA,cAAA;AAzBN;AAnIA;EAgKM,yBAAA;AA1BN;AAtIA;EAqKI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;AA5BJ;AA9IA;EA8KI,cAAA;EACA,aAAA;EACA,cAAA;EACA,gCAAA;EACA,oCAAA;EACA,yBAAA;AA7BJ;AA+BI;EACE,oCAAA;AA7BN;AAgCI;EACE,oCAAA;EACA,yBAAA;AA9BN;AA7JA;EAgMI,cAAA;EACA,aAAA;EACA,cAAA;EACA,gCAAA;EACA,oCAAA;EACA,iCAAA;EACA,yBAAA;AAhCJ;AAkCI;EACE,oCAAA;AAhCN;AAmCI;EACE,yBAAA;EACA,gCAAA;AAjCN;AA7KA;EAmNI,cAAA;EACA,gCAAA;EACA,yBAAA;AAnCJ;AAqCI;EACE,oDAAA;AAnCN;AArLA;EA6NI,oBAAA;AArCJ;AAxLA;EAiOI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;AAtCJ;AAwCI;EACE,0BAAA;AAtCN;AAvMA;EAkPI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,4BAAA;EACA,qBAAA;EACA,0CAAA;EACA,oBAAA;EACA,cAAA;AAxCJ;AAnNA;EA+PI,cAAA;EACA,cAAA;AAzCJ","sourcesContent":["@import '../colors';\n@import '../spacing';\n\n:local {\n  .section {\n    display: flex;\n    flex-direction: column;\n    gap: @spacing-100;\n    padding: @spacing-100;\n    background-color: @color-blue-099;\n    border: 1px solid @color-blue-095;\n    border-radius: @spacing-50;\n  }\n\n  .sectionHeader {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    gap: @spacing-75;\n  }\n\n  .sectionIcon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    width: @spacing-200;\n    height: @spacing-200;\n    border-radius: @spacing-50;\n    background-color: @color-blue-095;\n    color: @color-blue-050;\n  }\n\n  .sectionHeaderText {\n    display: flex;\n    flex-direction: column;\n    gap: @spacing-25;\n    min-width: 0;\n  }\n\n  .sectionTitle {\n    margin: 0;\n    font-size: 0.9375rem;\n    font-weight: 600;\n    color: @color-asphalt-grey-020;\n  }\n\n  .sectionDescription {\n    margin: 0;\n    font-size: 0.8125rem;\n    color: @color-asphalt-grey-050;\n    line-height: 1.4;\n  }\n\n  // ── Completed rows ────────────────────────────────────────────────\n  .completedList {\n    display: flex;\n    flex-direction: column;\n    gap: @spacing-50;\n  }\n\n  .completedRow {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: @spacing-75;\n    padding: @spacing-100;\n    background-color: @color-white;\n    border: 1px solid @color-asphalt-grey-090;\n    border-radius: @spacing-50;\n    min-height: @spacing-250;\n  }\n\n  .completedBadge {\n    font-weight: 600;\n    font-size: 0.875rem;\n    line-height: 1.5;\n    color: @color-asphalt-grey-020;\n    min-width: 1.5rem;\n  }\n\n  .completedSeparator {\n    color: @color-asphalt-grey-070;\n    font-size: 0.75rem;\n    line-height: 1.5;\n    user-select: none;\n  }\n\n  .completedText {\n    font-size: 0.875rem;\n    line-height: 1.5;\n    color: @color-asphalt-grey-040;\n    flex: 1;\n    min-width: 0;\n    overflow-x: hidden;\n    overflow-y: visible;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n\n  // ── Pending (in-progress) rows ────────────────────────────────────\n  .pendingList {\n    display: flex;\n    flex-direction: column;\n    gap: @spacing-100;\n  }\n\n  .pendingRow {\n    display: flex;\n    flex-direction: row;\n    gap: @spacing-75;\n    align-items: flex-end;\n    flex-wrap: wrap;\n  }\n\n  .fieldGroup {\n    display: flex;\n    flex-direction: column;\n    gap: @spacing-25;\n    flex: 1;\n    min-width: 8rem;\n  }\n\n  .fieldGroupWide {\n    flex: 2;\n    min-width: 10rem;\n  }\n\n  .fieldLabel {\n    font-size: 0.75rem;\n    color: @color-asphalt-grey-050;\n    line-height: 1.2;\n  }\n\n  .select {\n    flex: 1;\n    min-width: 0;\n  }\n\n  .selectWide {\n    flex: 2;\n    min-width: 0;\n  }\n\n  .selectControl {\n    width: 100%;\n    background-color: @color-white;\n    border-radius: @spacing-50;\n\n    :global(.MuiOutlinedInput-notchedOutline) {\n      border-color: @color-asphalt-grey-090;\n    }\n\n    &:hover :global(.MuiOutlinedInput-notchedOutline) {\n      border-color: @color-asphalt-grey-075;\n    }\n\n    :global(.MuiSelect-select) {\n      font-size: 0.875rem;\n      color: @color-asphalt-grey-030;\n    }\n\n    :global(.MuiSvgIcon-root) {\n      color: @color-light-blue-070 !important;\n    }\n  }\n\n  .actionButtons {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: @spacing-50;\n    flex-shrink: 0;\n    padding-bottom: 1px;\n  }\n\n  .confirmButton {\n    flex-shrink: 0;\n    width: @spacing-250;\n    height: @spacing-250;\n    border-radius: @spacing-50 !important;\n    background-color: @color-green-095 !important;\n    color: @color-green-050 !important;\n\n    &:hover {\n      background-color: @color-green-090 !important;\n    }\n\n    &:global(.Mui-disabled) {\n      background-color: @color-asphalt-grey-095 !important;\n      color: @color-asphalt-grey-070 !important;\n    }\n  }\n\n  .removeButton {\n    flex-shrink: 0;\n    width: @spacing-250;\n    height: @spacing-250;\n    border-radius: @spacing-50 !important;\n    border: 1px solid @color-asphalt-grey-090 !important;\n    background-color: @color-white !important;\n    color: @color-asphalt-grey-050 !important;\n\n    &:hover {\n      background-color: @color-asphalt-grey-099 !important;\n    }\n\n    &:global(.Mui-disabled) {\n      color: @color-asphalt-grey-075 !important;\n      border-color: @color-asphalt-grey-095 !important;\n    }\n  }\n\n  .completedRemoveButton {\n    flex-shrink: 0;\n    border-radius: @spacing-50 !important;\n    color: @color-red-050 !important;\n\n    &:hover {\n      background-color: fade(@color-red-050, 8%) !important;\n    }\n  }\n\n  .tooltipWrapper {\n    display: inline-flex;\n  }\n\n  .addButton {\n    display: flex;\n    align-items: center;\n    gap: @spacing-50;\n    background: none;\n    border: none;\n    cursor: pointer;\n    color: @color-light-blue-050;\n    font-size: 0.875rem;\n    padding: 0;\n    width: fit-content;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  .emptyState {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: @spacing-75;\n    padding: @spacing-100;\n    border: 1.5px dashed @color-blue-090;\n    border-radius: @spacing-50;\n    background-color: fade(@color-white, 80%);\n    font-size: 0.8125rem;\n    color: @color-asphalt-grey-050;\n  }\n\n  .emptyStateIcon {\n    color: @color-blue-050;\n    flex-shrink: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `style__section--Q_QsB`,
	"sectionHeader": `style__sectionHeader--mKm2F`,
	"sectionIcon": `style__sectionIcon--tkYk6`,
	"sectionHeaderText": `style__sectionHeaderText--vc4xR`,
	"sectionTitle": `style__sectionTitle--n55YT`,
	"sectionDescription": `style__sectionDescription--dl0ul`,
	"completedList": `style__completedList--ozTF1`,
	"completedRow": `style__completedRow--_oeer`,
	"completedBadge": `style__completedBadge--NUTr2`,
	"completedSeparator": `style__completedSeparator--XoYD9`,
	"completedText": `style__completedText--OBGL8`,
	"pendingList": `style__pendingList--GmhWT`,
	"pendingRow": `style__pendingRow--ETOTU`,
	"fieldGroup": `style__fieldGroup--jb78B`,
	"fieldGroupWide": `style__fieldGroupWide--OlVvI`,
	"fieldLabel": `style__fieldLabel--M5mGx`,
	"select": `style__select--z3sil`,
	"selectWide": `style__selectWide--WxH0i`,
	"selectControl": `style__selectControl--AcvqG`,
	"actionButtons": `style__actionButtons--hm8Pg`,
	"confirmButton": `style__confirmButton--mNxtO`,
	"removeButton": `style__removeButton--NcplM`,
	"completedRemoveButton": `style__completedRemoveButton--mNyLO`,
	"tooltipWrapper": `style__tooltipWrapper--YviRN`,
	"addButton": `style__addButton--nSsoT`,
	"emptyState": `style__emptyState--Tedj0`,
	"emptyStateIcon": `style__emptyStateIcon--Tta_Y`
};
export default ___CSS_LOADER_EXPORT___;
